<template>
  <div>
    <NtSpacing v-if="output" :cols="3">
      <a
        v-for="(result, l) in output.results"
        :key="l"
        :href="result.website_url"
        target="_blank"
        class="relative rounded-lg bg-white dark:bg-neutral-800 shadow-sm flex flex-col text-sm cursor-pointer hover:outline-solid hover:outline-4 hover:outline-offset-2 hover:outline-accent-600 dark:hover:outline-accent-500 hover:scale-105 transition-transform">
        <img :src="result.image" class="block w-full aspect-photo object-center object-cover rounded-t-md" />

        <div class="p-3">
          <p class="font-semibold">{{ result.display_address }}</p>
          <p>
            <span v-if="result.bedrooms">{{ result.bedrooms }} bed </span>
            <span>{{ result.property_type }}</span>
          </p>
          <p class="mt-2">{{ result.price }}</p>
        </div>

        <div
          v-if="result.status !== 'Available'"
          class="bg-accent-500 text-white text-xs py-1 px-2 absolute top-2 right-2 rounded">
          {{ result.status }}
        </div>
      </a>
    </NtSpacing>
  </div>
</template>

<script>
import NtSpacing from '@/components/general/NtSpacing.vue'

export default {
  components: { NtSpacing },
  props: {
    input: {
      type: [Object, null],
      required: true
    },
    output: {
      required: true
    }
  }
}
</script>
